"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTL_MAX_TOTAL_WEIGHT = exports.LTL_MINIMUM_UNIT_PRICE = exports.LTL_MAXIMUM_UNIT_PRICE = exports.LTL_MAX_PALLET_WEIGHT_FORWARDING = exports.LTL_MAX_PALLET_WEIGHT_DIRECT = exports.LTL_MAXIMUM_PALLETS = exports.LTL_MAXIMUM_TOTAL_WEIGHT = exports.LTL_MINIMUM_TOTAL_WEIGHT = exports.LTL_MAX_PALLET_HEIGHT = exports.LTL_MAX_PALLET_LENGTH = void 0;
exports.LTL_MAX_PALLET_LENGTH = 50;
exports.LTL_MAX_PALLET_HEIGHT = 90;
exports.LTL_MINIMUM_TOTAL_WEIGHT = 150;
exports.LTL_MAXIMUM_TOTAL_WEIGHT = 40000;
exports.LTL_MAXIMUM_PALLETS = 6;
exports.LTL_MAX_PALLET_WEIGHT_DIRECT = 1800;
exports.LTL_MAX_PALLET_WEIGHT_FORWARDING = 2500;
exports.LTL_MAXIMUM_UNIT_PRICE = 25;
exports.LTL_MINIMUM_UNIT_PRICE = 0.1;
exports.FTL_MAX_TOTAL_WEIGHT = 46000;
//# sourceMappingURL=LtlConstants.js.map